export const logoNegative = ['608 134', `
  <title>Microbiome edge</title>
  <g>
    
  </g>
`]
